import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Subrecipient: An external entity receiving a portion of a research award, by a subaward, to assist in project-related work.',
    name: 'Subrecipients',
    partialId: PartialId.Standard.create('subrecips'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
